

import React from "react";
import ReactDOM from "react-dom";

import { Router, Route, Switch } from "react-router-dom";
import { createStore,applyMiddleware } from "redux";
import indexRoutes from "./routes/index.jsx";
import MainRouter from "./routes/Router"
import * as types from "./types";
import { Provider } from "react-redux";
import { Reducer, startApp } from "./reducers/action-reducer";
import "src/assets/scss/material-dashboard-pro-react.css?v=1.3.0";



const isPromise = action => action && typeof action.then == 'function'

const promiseMiddleware = ({ dispatch }) => next => action => {
  const success = result => {
    dispatch({ ...action, payload: result })
    return result
  }
  const failure = error => {
    dispatch({ ...action, payload: error, error: true })
    return Promise.reject(error)
  }
  const promisy = isPromise(action.payload)
  return promisy ? action.payload.then(success, failure) : next(action)
}

const thunkMiddleware = ({ dispatch }) => next => action => {
  ;
  if (action && typeof action.payload == 'function') {
    const payload = action.payload(dispatch)
    if (payload) {
      return next({
        ...action,
        payload
      })
    }
    throw new Error('thunk returned nothing')
  }

  return next(action)
}

const middleware = applyMiddleware(
  thunkMiddleware,
  promiseMiddleware
 // ReduxThunk
)
const store = createStore(Reducer, types.getDefaultState());
let state: types.IState = store.getState();

ReactDOM.render(
  <Provider store={store}>
       <MainRouter />
  </Provider>,
  document.getElementById("root")
);
;
store.dispatch(startApp(store.dispatch));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx